import React from 'react'
import classNames from 'classnames'

function MediaImage({ src, alt_text = '', modifierClasses = [] }) {
  const thumbnailClasses = classNames(
    'thumbnail',
    modifierClasses
  )
  return (
    <div className="media__image">
      <div className={thumbnailClasses}>
        {src && (
          <img src={src} alt={alt_text} />
        )}
      </div>
    </div>
  )
}

export default MediaImage
